import React from "react";
import { Link } from "react-router-dom";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
import LogoutPage from './Logout';
import { Dropdown } from "react-bootstrap";

import logo from '../../../images/login-logo.png';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

function getLoggedInUser() {
  try {
    const parsed = JSON.parse(localStorage.getItem("userDetails") || "{}");
    const name = parsed?.userName || parsed?.name || "Admin";
    const imageUrl = parsed?.imageUrl || "";
    return { name, imageUrl };
  } catch {
    return { name: "Admin", imageUrl: "" };
  }
}

function getInitials(name) {
  return name
    .split(" ")
    .filter(Boolean)
    .map((w) => w[0].toUpperCase())
    .slice(0, 2)
    .join("");
}

function getLogoRoute() {
    try {
        const parsed = JSON.parse(localStorage.getItem("userDetails") || "{}");
        const roleName = (parsed?.roleId?.roleName || parsed?.roleName || "").toLowerCase();
        return roleName === "employees" ? "/employee-view" : "/dashboard";
    } catch {
        return "/dashboard";
    }
}

const Header = ({ toggle }) => {
  const { name: loggedInName, imageUrl } = getLoggedInUser();
  const resolvedImage = imageUrl
    ? (imageUrl.startsWith("http") ? imageUrl : `${API_BASE_URL}/${imageUrl.replace(/^\//, "")}`)
    : "";
   var path = window.location.pathname.split("/");
   var name = path[path.length - 1].split("-");
   var filterName = name.length >= 3 ? name.filter((n, i) => i > 0) : name;
   var finalName = filterName.includes("app")
      ? filterName.filter((f) => f !== "app")
      : filterName.includes("ui")
      ? filterName.filter((f) => f !== "ui")
      : filterName.includes("uc")
      ? filterName.filter((f) => f !== "uc")
      : filterName.includes("basic")
      ? filterName.filter((f) => f !== "basic")
      : filterName.includes("form")
      ? filterName.filter((f) => f !== "form")
      : filterName.includes("table")
      ? filterName.filter((f) => f !== "table")
      : filterName.includes("page")
      ? filterName.filter((f) => f !== "page")
      : filterName.includes("email")
      ? filterName.filter((f) => f !== "email")
      : filterName.includes("ecom")
      ? filterName.filter((f) => f !== "ecom")
      : filterName.includes("chart")
      ? filterName.filter((f) => f !== "chart")
      : filterName.includes("editor")
      ? filterName.filter((f) => f !== "editor")
      : filterName;

	var page_name = (finalName.join(" ") === '')?'Dashboard':finalName.join(" ");

   return (
      <div className="header">
         <div className="header-content">
            <nav className="navbar navbar-expand">
               <div className="collapse navbar-collapse justify-content-between">
                  <div className="header-left">
                     <div
                        className="dashboard_bar"
                        style={{ textTransform: "capitalize" }}
                     >
                        {page_name === "hod view" ? "Job View" : page_name}
                     </div>
                  </div>
                  <div className="header-right header-logo">
                     <a class="" href={getLogoRoute()}>
                        <img src={logo} alt="Logo"/>
                     </a>
                  </div>

                  {/* <ul className="navbar-nav header-right">
                     <Dropdown as="li"
                        className={`nav-item header-profile`}
                     >
                        <Dropdown.Toggle to={"#"} as="a"
                           className="nav-link  i-false"
                        >
                           <div className="header-info">
                              <span>{loggedInName}</span>
                           </div>
                           {resolvedImage ? (
                             <img src={resolvedImage} width="36" height="36" alt={loggedInName}
                               style={{ borderRadius: "50%", objectFit: "cover" }} />
                           ) : (
                             <div style={{
                               width: 36, height: 36, borderRadius: "50%",
                               background: "#6366f1", color: "#fff",
                               display: "flex", alignItems: "center", justifyContent: "center",
                               fontSize: 13, fontWeight: 700, flexShrink: 0,
                             }}>
                               {getInitials(loggedInName)}
                             </div>
                           )}
                        </Dropdown.Toggle>
                        <Dropdown.Menu align="end"
                           className={`dropdown-menu  ${
                              toggle === "profile" ? "show" : ""
                           }`}
                        >
                           <Link
                              to="/app-profile"
                              className="dropdown-item ai-icon"
                           >
                              <svg
                                 id="icon-user1"
                                 xmlns="http://www.w3.org/2000/svg"
                                 className="text-primary"
                                 width="18"
                                 height="18"
                                 viewBox="0 0 24 24"
                                 fill="none"
                                 stroke="currentColor"
                                 strokeWidth="2"
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                              >
                                 <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                 <circle cx="12" cy="7" r="4"></circle>
                              </svg>
                              <span className="ms-2">Profile </span>
                           </Link>

                           <LogoutPage />
                        </Dropdown.Menu>
                     </Dropdown>
                  </ul> */}
               </div>
            </nav>
         </div>
      </div>
   );
};

export default Header;
